import { useDispatch, useSelector } from "react-redux";
import { INSIGHTS_TYPE } from "../templates/strings";
import { updateRecordActionState } from "../store/slices/funnelInfo";
import { saveRecordAction, deleteQuestionVisit } from "../services/api";

export const useRecordAction = () => {
  const dispatch = useDispatch();
  const {
    funnel,
    outcome,
    isFormBack,
    allQuestions,
    currentQuestion,
    questionToRemove,
    recordActionState
  } = useSelector((state) => state.funnelInfo);
  const zipInfo = useSelector((state) => state.zipInfo);
  let senderId = localStorage.getItem("senderId");
  const handleRecordAction = async () => {
    let recordAction = { ...recordActionState };

    if (!recordAction?.nextInsightRefId) {
      const nextInsightData =
        currentQuestion === allQuestions.length
          ? Object.keys(outcome)?.length
            ? {
                nextInsightRefId: outcome?.id,
                nextInsightType: outcome?.outcomeLogic
              }
            : {
                nextInsightRefId: INSIGHTS_TYPE.ZIP,
                nextInsightType: INSIGHTS_TYPE.ZIP
              }
          : {
              nextInsightRefId: allQuestions[currentQuestion]?._id,
              nextInsightType: INSIGHTS_TYPE.QUESTION
            };
      recordAction.nextInsightRefId = nextInsightData.nextInsightRefId;
      recordAction.nextInsightType = nextInsightData.nextInsightType;
    }
    const payload = {
      funnelId: funnel.id,
      funnelVersion: funnel.activeVersion,
      senderId,
      insightRefId: recordAction.insightRefId,
      insightType: recordAction.insightType,
      answerIds: recordAction.answerId,
      nextInsightRefId: recordAction.nextInsightRefId,
      nextInsightType: recordAction.nextInsightType,
      isLandingPage: recordAction.isLandingPage
    };
    if (recordAction.leadId) {
      payload.leadId = recordAction.leadId;
    }
    dispatch(updateRecordActionState({}));
    try {
      await saveRecordAction(payload);
    } catch (error) {
      console.log("Error in saving record action: ", error);
    }
  };

  const handleRemoveAction = async (questionId) => {
    try {
      const payload = {
        senderId,
        funnelId: funnel.id,
        funnelVersion: funnel.activeVersion,
        insightId: questionId
      };
      if (
        !questionId &&
        questionToRemove === allQuestions.length &&
        !zipInfo.isSubmitted &&
        !isFormBack
      ) {
        payload.insightId = INSIGHTS_TYPE.ZIP;
      }
      if (isFormBack && !questionId) {
        payload.insightId = INSIGHTS_TYPE.LEAD;
      }

      await deleteQuestionVisit(payload);
    } catch (error) {
      console.log("Error in saving record action: ", error);
    }
  };

  return { handleRecordAction, handleRemoveAction };
};
